<script lang="ts" setup>
import { useTranslate } from '@tolgee/vue'

interface Props {
  title: string
  description: string
  confirmText?: string
}

interface Events {
  (e: 'confirm'): void
}

defineProps<Props>()
const emit = defineEmits<Events>()
const model = defineModel({ default: false })

const { t } = useTranslate('local')
</script>

<template>
  <v-dialog v-model="model" max-width="580">
    <v-card :title="title">
      <v-card-text>
        {{ description }}
      </v-card-text>

      <v-card-actions>
        <GsButton type="secondary" @click="model = false" width="125">
          {{ t('confirmDialog.cancel') }}
        </GsButton>
        <GsButton type="success" @click="emit('confirm')" width="165">
          {{ confirmText || t('confirmDialog.ok') }}
        </GsButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.v-dialog {
  .v-card {
    padding: 16px;
    border-radius: 20px !important;
    background: var(--lightest);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;

    @include media('sm-and-up') {
      padding: 32px;
    }

    :deep(.v-card-item) {
      padding: 0 !important;
    }

    :deep(.v-card-title) {
      font-size: 24px;
      font-weight: 700;
      letter-spacing: 0;
      line-height: normal;

      @include media('sm-and-up') {
        font-size: 32px;
      }
    }

    .v-card-text {
      font-size: 16px !important;
      padding: 0 !important;
      margin: 16px 0;

      @include media('sm-and-up') {
        font-size: 20px !important;
        margin: 32px 0;
      }
    }

    .v-card-actions {
      padding: 0;
      gap: 16px;
      justify-content: flex-end;

      @include media('sm-and-down') {
        flex-direction: column;

        .btn {
          width: 100%;
        }
      }
    }
  }
}
</style>
